import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withHashLocation } from '@angular/router';
import { CoreModule } from '@qaroni-core/core.module';
import { provideInitialize } from '@qaroni-core/providers/provide-initializer.provider';
import { provideSentry } from '@qaroni-core/providers/provide-sentry.provider';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(BrowserModule, CoreModule),
    provideAnimations(),
    provideRouter(routes, withHashLocation()),
    provideInitialize(),
    provideHttpClient(withInterceptorsFromDi()),
    provideSentry(),
  ],
};
